const Header = () => {

    return (
        <div className='header'>
            <h1>Scythe Randomizer</h1>
        </div>
    )
    
    }
    
    export default Header